(() => {
    let menuCategories = document.getElementsByClassName('header__categories-nav');
    let menuCategoriesOptions = menuCategories[0].getElementsByClassName('contents-item');

    let menuHeaderLinkList = menuCategories[0].getElementsByClassName('header__link-list');
    let promoWrapperBrands = menuCategories[0].getElementsByClassName('navigation-promo__wrapper-brands');
    let firstOptionDistance = null;

    let tabsContainerMobile = document.getElementsByClassName('tabs-container-mob');
    let tabsHeaderBrandTabsMobile = document.getElementsByClassName('header__brands-tab--mobile');
    let tabsMobile = tabsContainerMobile[0].getElementsByClassName('tab-item');
    let tabsContainer = document.getElementsByClassName('tabs-container-desk');
    let tabs = tabsContainer[0].getElementsByClassName('tab-item');

    tabsHeaderBrandTabsMobile[0].style.setProperty('--tabs-overflow', 'hidden');

    let megaMenus = document.getElementsByClassName('mega-menu__nav');
    let shopAll = document.getElementsByClassName('mega-menu__shop');

    var window_width = null;
    let location = window.location.href;
    let tabLeftPosition = null;

    let searchvNavbar = document.getElementsByClassName('header__search-container');
    let body = '';
    let bodyDataBrand = '';

    let megamenuOptionsContainer = document.getElementsByClassName('mega-menu');

    widthActual();

    function getDistance() {
        if (menuCategories) {
            if (menuCategoriesOptions) {
                firstOptionDistance = menuHeaderLinkList[0].offsetLeft;

                if (promoWrapperBrands[0]) if (promoWrapperBrands) promoWrapperBrands[0].style.setProperty('--wrapper-brands-padding-left', `${firstOptionDistance}px`);
            }
        }
    }

    function getLogoTabPosition() {
        let tabLogoImage = '';
        let tabLogoImageNew = '';

        return new Promise((resolve, reject) => {
            let logoImagesLogos = '';
            let megamenuBrands = '';
            let megamenuBrandsRect = '';
            let megamenuBrandsMargin = 0;
            body = document.getElementsByTagName('body');
            bodyDataBrand = body[0].getAttribute('data-brand');

            if (window_width < 1150) {
                logoImagesLogos = tabsContainerMobile[0].getElementsByClassName('image-logo');
            } else {
                let tabsContainer = document.getElementsByClassName('header__brands-tab--desk');
                logoImagesLogos = tabsContainer[0].getElementsByClassName('image-logo');
            }

            for (let i = 0; i < logoImagesLogos.length; i++) {
                const logoImage = logoImagesLogos[i];

                let diferenceWidthHeight = logoImagesLogos[0].getBoundingClientRect().top + (logoImagesLogos[0].getBoundingClientRect().height - logoImagesLogos[1].getBoundingClientRect().height);

                let elDistanceToTop = logoImagesLogos[1].getBoundingClientRect().top - logoImagesLogos[0].getBoundingClientRect().top;

                if (i == 1) {
                    logoImage.style.setProperty('--margin-top', `${elDistanceToTop}px`);

                    if (widthActual < 1150) {
                        logoImage.style.setProperty('--tab-decor-height', `${logoImagesLogos[0].getBoundingClientRect().height * 1.75}px`);
                    }
                }
            }

            if (!location.includes('decor') && !window.location.href.includes('Decor+Living+House') && (bodyDataBrand != 'acento' || bodyDataBrand != 'index') && bodyDataBrand != 'decor-living') {
                let tab1 = tabs[0].getBoundingClientRect();
                tabLogoImage = tabs[0].getElementsByClassName('tab-link');
                let tabLogoImageContainer = tabLogoImage[0].getElementsByClassName('image-container');
                let tabLogo = tabLogoImageContainer[0].getElementsByClassName('image-logo');

                tabLogoImageNew = tabLogo[0].offsetLeft;

                let calculatedMarginLeft = '';

                if(!location.includes('decor') && !window.location.href.includes('Decor+Living+House') && bodyDataBrand == 'decor-living') {
                    megamenuBrands = document.getElementsByClassName('mega-menu-brands-decor');

                } else {
                    megamenuBrands = document.getElementsByClassName('mega-menu-brands-acento');
                }

                if (megamenuBrands.length != 0) {
                    megamenuBrandsRect = megamenuBrands[0].getBoundingClientRect();
                }

                if (window_width >= 1150 && window_width < 1200) {
                    calculatedMarginLeft = tabLogoImage[0].getBoundingClientRect().x - tabLogoImage[0].getBoundingClientRect().width; //ok
                    let computedStyle = window.getComputedStyle(megamenuBrands[0]);

                    if(!location.includes('decor') && !window.location.href.includes('Decor+Living+House') && bodyDataBrand == 'decor-living') {
                        menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `0px`);
                    } else {
                        menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left}px`);
                    }



                } else if (window_width >= 1200 && window_width < 1600) {
                    calculatedMarginLeft = menuCategoriesOptions[0].getBoundingClientRect().x - menuCategoriesOptions[0].getBoundingClientRect().width; //ok

                    if(!location.includes('decor') && !window.location.href.includes('Decor+Living+House') && bodyDataBrand == 'decor-living') {
                        menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left}px`);
                    }

                    menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left}px`);

                } else if (window_width >= 1600 && window_width < 1800) {
                    calculatedMarginLeft = 175; //ok

                    if(!location.includes('decor') && !window.location.href.includes('Decor+Living+House') && bodyDataBrand == 'decor-living') {
                        menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `0px`);
                    } else {
                        menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left}px`);
                    }

                } else {
                    let optionMenuCategoriesOptions = menuCategoriesOptions[0].getBoundingClientRect();

                    calculatedMarginLeft = 175;

                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);

                    let computedStyle = window.getComputedStyle(megamenuBrands[0]);

                    if (megamenuBrands.length != 0) {
                        megamenuBrandsMargin = (menuCategoriesOptions[0].offsetLeft - megamenuBrandsRect.width) - 50;
                        menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left}px`);
                    }
                }

                let optionMenuCategoriesOptions = menuCategoriesOptions[0].getBoundingClientRect();

                setMenuListPosition(tabLogo[0].getBoundingClientRect().left);
                resolve();

            } else {
                let tab1 = tabs[0].getBoundingClientRect();
                let tab2 = tabs[1].getBoundingClientRect();

                tabLogoImage = tabs[1].getElementsByClassName('tab-link');
                let tabLogoImageContainer = tabLogoImage[0].getElementsByClassName('image-container');
                let tabLogo = tabLogoImageContainer[0].getElementsByClassName('image-logo');

                tabLogoImageNew = tabLogo[0].offsetLeft;

                tabLeftPosition = tabLogoImage[0].offsetLeft;
                menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${tab1.width + tabLeftPosition}px`);

                let tabsContainer = document.getElementsByClassName('header__brands-tab--desk');
                let tabsContainerRect = tabsContainer[0].getBoundingClientRect();

                let menuCategoriesRect = menuCategories[0].getBoundingClientRect();

                menuHeaderLinkList[0].style.setProperty('--menu-categories-left', `${menuCategories[0].offsetLeft - (menuCategories[0].offsetLeft - 27.5)}px`);


                let calculatedMarginLeft = '';

                megamenuBrands = document.getElementsByClassName('mega-menu-brands-decor');
                megamenuBrandsRect = megamenuBrands[0].getBoundingClientRect();

                megamenuBrandsMargin = (menuCategoriesOptions[0].offsetLeft - megamenuBrandsRect.width) - megamenuBrandsRect.width - 50;

                firstOptionDistance = menuHeaderLinkList[0].offsetLeft;

                megamenuBrands[0].style.setProperty('--wrapper-brands-padding-left', `${firstOptionDistance}px`);

                if (window_width >= 1150 && window_width < 1200) {
                    calculatedMarginLeft = '-30';
                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);

                    if(bodyDataBrand == 'decor-living') {
                        megamenuBrands[0].style.setProperty('--margin-left-megamenu-brands', `0px`);
                    }

                } else if (window_width >= 1200 && window_width < 1800) {
                    calculatedMarginLeft = '-25';
                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);

                    if(bodyDataBrand == 'decor-living') {
                        megamenuBrands[0].style.setProperty('--margin-left-megamenu-brands', `0px`);
                    }

                } else {
                    let optionMenuCategoriesOptions = menuCategoriesOptions[0].getBoundingClientRect();
                    let computedStyle = window.getComputedStyle(megamenuBrands[0]);

                    calculatedMarginLeft = 28;
                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);

                    calculatedMarginLeft = menuCategoriesOptions[0].getBoundingClientRect().x - menuCategoriesOptions[0].getBoundingClientRect().width;

                    menuHeaderLinkList[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left}px`);
                }

                setMenuListPosition(tabLogo[0].getBoundingClientRect().left);
                resolve();
            }
        });
    }

    function setMenuListPosition(tabLeftPosition, type) {
        let widthOriginal = window.innerWidth;

        if (megaMenus.length > 0) {
            for (let i = 0; i < megaMenus.length; i++) {
                const megaMenu = megaMenus[i];
                let computedStyle = null;
                let paddingLeft = null;
                let paddingLeftValue = null;

                if (widthOriginal == window_width) {
                    computedStyle = window.getComputedStyle(megaMenu);
                    paddingLeft = computedStyle.getPropertyValue('padding-left');
                    paddingLeftValue = paddingLeft.replace('px', '');
                    megaMenu.style.setProperty('padding-left', `${tabLeftPosition}px`);

                    if (shopAll.length > 0) {
                        for (let i = 0; i < shopAll.length; i++) {
                            const shop = shopAll[i];
                            shop.style.setProperty('--padding-left-shop-all', `${tabLeftPosition}px`);
                        }
                    }

                } else {
                    computedStyle = window.getComputedStyle(megaMenu);
                    paddingLeft = computedStyle.getPropertyValue('padding-left');
                    paddingLeftValue = paddingLeft.replace('px', '');

                    megaMenu.style.setProperty('padding-left', `${tabLeftPosition}px`);
                }
            }
        }
    }

    function widthActual() {
        return window_width = window.innerWidth;
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        getLogoTabPosition().then(() => {
            getDistance();
        });
    });

    window.addEventListener("resize", (event) => {
        widthActual();

        getLogoTabPosition().then(() => {
            getDistance();
        });
    });
})()